import { createContext } from 'react';
import { Organization } from './types';

export const CaOrganizationContext = createContext<{
  organization: Organization;
  setOrganizationId: (organizationId: string | null) => void;
  isLoading: boolean;
}>({
  organization: null,
  setOrganizationId: () => {
    throw new Error('setOrganizationId must be used within CaOrganizationProvider');
  },
  isLoading: false,
});
